import React from "react";

import { HitsPerPage } from "@components/Search/SearchResults/StateComponents/HitsPerPage/hitsPerPage.container";

type HitsPerPageProps = {
    className?: string;
};

const ProductHitsPerPage = ({ className }: HitsPerPageProps) => (
    <HitsPerPage component={"PRODUCT_HITS_PER_PAGE"} className={className} />
);

export { ProductHitsPerPage };
